import { all, call, put, takeLatest } from "redux-saga/effects";
import { findAllGroups } from "../services/groups.service";
import { groupsActions } from "../store/groups.store";
import { onSystemFetchAllEmployees } from "./employees.saga";

/**
 * システムが全グループデータを取得する
 */
export function* onSystemFetchAllGroups() {
  const groups = yield call(findAllGroups);
  yield put(groupsActions.REDUCER_SET_GROUPS(groups));
}

/**
 * グループSaga
 */
export function* groupsSagas() {
  yield all([
    yield takeLatest(
      groupsActions.SYSTEM_FETCH_ALL_GROUPS,
      onSystemFetchAllEmployees
    )
  ]);
}
